/**
 * Text Visit 相关常量定义
 */

// Feature Type 功能类型枚举
export enum EFeatureType {
    ASSESSMENT = 'ASSESSMENT',
    TEXT_VISIT_WORKFLOW = 'TEXT_VISIT_WORKFLOW',
    INTAKE_FORM_WORKFLOW = 'INTAKE_FORM_WORKFLOW',
}

// Layout 布局选项枚举
export enum ELayoutType {
    DEFAULT = 'default',
    WL_FULL_NOTE_HORIZON_STYLE = 'WLFullNoteHorizonStyle',
    WL_FULL_NOTE = 'WLFullNote',
}

// Layout 选项配置
export const LAYOUT_OPTIONS = [
    {
        label: 'Left & right',
        value: ELayoutType.WL_FULL_NOTE_HORIZON_STYLE,
    },
    {
        label: 'Top & bottom',
        value: ELayoutType.DEFAULT,
    },
    {
        label: 'Full screen',
        value: ELayoutType.WL_FULL_NOTE,
    },
];

// Text Visit 默认金额
export const DEFAULT_TEXT_VISIT_AMOUNT = 39.00;

// Case Status 病例状态枚举
export enum ECaseStatus {
    PENDING = 'PENDING',
    UNASSIGNED = 'UNASSIGNED',
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    CANCELED = 'CANCELED',
}

// Case Status 显示选项
export const CASE_STATUS_OPTIONS = [
    { label: 'Pending', value: ECaseStatus.PENDING },
    { label: 'Unassigned', value: ECaseStatus.UNASSIGNED },
    { label: 'Active', value: ECaseStatus.ACTIVE },
    { label: 'Closed', value: ECaseStatus.CLOSED },
    { label: 'Canceled', value: ECaseStatus.CANCELED },
];

// Case Status 显示文本映射
export const CASE_STATUS_DISPLAY_MAP: Record<string, string> = {
    [ECaseStatus.PENDING]: 'Pending',
    [ECaseStatus.UNASSIGNED]: 'Unassigned',
    [ECaseStatus.ACTIVE]: 'Active',
    [ECaseStatus.CLOSED]: 'Closed',
    [ECaseStatus.CANCELED]: 'Canceled',
};

// Payment Status 支付状态枚举
export enum EPaymentStatus {
    /** Payment has been successfully completed */
    SUCCEEDED = 'SUCCEEDED',
    /** Refund has succeeded */
    REFUNDED = 'REFUNDED',
    /** Refund has failed */
    REFUNDED_FAILED = 'REFUNDED_FAILED',
    /** Refund is processing */
    REFUNDED_PROCESSING = 'REFUNDED_PROCESSING',
}

// Payment Status 显示选项
export const PAYMENT_STATUS_OPTIONS = [
    { label: 'Paid', value: EPaymentStatus.SUCCEEDED },
    { label: 'Refunded', value: EPaymentStatus.REFUNDED },
    { label: 'Refund Failed', value: EPaymentStatus.REFUNDED_FAILED },
    { label: 'Refund Processing', value: EPaymentStatus.REFUNDED_PROCESSING },
];

// Payment Status 显示文本映射
export const PAYMENT_STATUS_DISPLAY_MAP: Record<string, string> = {
    [EPaymentStatus.SUCCEEDED]: 'Paid',
    [EPaymentStatus.REFUNDED]: 'Refunded',
    [EPaymentStatus.REFUNDED_FAILED]: 'Refund Failed',
    [EPaymentStatus.REFUNDED_PROCESSING]: 'Refund Processing',
};

// Refund Status 退款状态枚举
export enum ERefundStatus {
    PENDING_REVIEW = 'PENDING_REVIEW',
    APPROVE_FULL = 'APPROVE_FULL',
    APPROVE_PARTIAL = 'APPROVE_PARTIAL',
    DENIED = 'DENIED',
    AUTO_APPROVED = 'AUTO_APPROVED',
}

// Refund Status 显示选项
export const REFUND_STATUS_OPTIONS = [
    { label: 'Pending review', value: ERefundStatus.PENDING_REVIEW },
    { label: 'Approved (Full)', value: ERefundStatus.APPROVE_FULL },
    { label: 'Approved (Partial)', value: ERefundStatus.APPROVE_PARTIAL },
    { label: 'Denied', value: ERefundStatus.DENIED },
    { label: 'Auto Approved', value: ERefundStatus.AUTO_APPROVED },
];

// Refund Status 显示文本映射
export const REFUND_STATUS_DISPLAY_MAP: Record<string, string> = {
    [ERefundStatus.PENDING_REVIEW]: 'Pending Review',
    [ERefundStatus.APPROVE_FULL]: 'Approve Full',
    [ERefundStatus.APPROVE_PARTIAL]: 'Approve Partial',
    [ERefundStatus.DENIED]: 'Denied',
    [ERefundStatus.AUTO_APPROVED]: 'Auto Approved',
};
